import request from "./request";

export function afterLogout(id) {
  return request().get("/api/iam/v1/a/odic/login?pflow=" + id);
}

export function logout(params) {
  return request().get("/api/iam/v1/a/odic/logout?pflow=" + params);
}
